<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewSettings.kkm.title") }}</h3>
    <v-card class="mt-2" elevation="0" :loading="!fetched">
      <v-row>
        <v-col cols="12" lg="6">
          <v-form ref="kkmParamsForm" :disabled="!fetched">
            <v-alert
                border="top"
                colored-border
                type="info"
                elevation="1"
            >
            Для работы с кассовым аппаратом необходимо дополнительно установить <a href="https://kkmserver.ru/KkmServer" target="_blank">ККМ http web-сервер</a> и <a href="https://kkmserver.ru/WiKi/Settings" target="_blank">расширение</a> в браузер для него.
            </v-alert>
            <v-divider class="mb-5"></v-divider>
            <v-text-field
              v-model="receiptsSettingsTemp.inn"
              :value="receiptsSettingsTemp.inn"
              :label="$t('viewSettings.kkm.inn')"
              :rules="[
                (v) => (!!v || v==='') || $t('form.validationErrors.field_is_required'),
              ]"
              outlined
            ></v-text-field>
            <v-radio-group
              v-model="receiptsSettingsTemp.nds"
              :rules="[
                (v) => (!!v || v===-1 || v===0) || $t('form.validationErrors.field_is_required'),
              ]"
            >
              <h3>{{ $t("viewSettings.kkm.nds") }}</h3>
              <v-radio
                v-for="nds in ndsValues"
                :key="nds.value"
                :label="nds.title"
                :value="nds.value"
              ></v-radio>
            </v-radio-group>
            <v-divider></v-divider>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="savingInProgress || !fetched"
              class="mt-5 white--text mr-4"
              elevation="0"
              color="red"
              @click="fillReceiptsSettingsTemp"
              @keyup.enter="fillReceiptsSettingsTemp"
            >
              {{ $t("common.cancel") }}
            </v-btn>
            <v-btn
                class="mr-4 mt-5"
                elevation="0"
                :title="$t('common.other_receipts')"
                @click="isVisibleReceiptsAdditionalWindow = !isVisibleReceiptsAdditionalWindow"
            >
              <v-icon color="warning">mdi-receipt</v-icon>
            </v-btn>
            <v-btn
              :disabled="savingInProgress || !fetched"
              :loading="savingInProgress"
              class="mt-5"
              color="primary"
              elevation="0"
              @click="submit"
              @keyup.enter="submit"
            >
              {{ $t("common.save") }}
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-card>
    <receipts-additional-window
        :show="isVisibleReceiptsAdditionalWindow"
        @hide="isVisibleReceiptsAdditionalWindow = false"
    ></receipts-additional-window>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import router from "../../router";
import ReceiptsAdditionalWindow from "../../components/receipts_additional/ReceiptsAdditionalWindow";

export default {
  name: "KKMComponent",
  components: {ReceiptsAdditionalWindow},
  data: () => ({
    isVisibleReceiptsAdditionalWindow: false,
    receiptsSettingsTemp: {
      nds: null,
      inn: '',
    },
    ndsValues: [
      {
        value: 20,
        title: "НДС 20%",
      },
      {
        value: 10,
        title: "НДС 10%",
      },
      {
        value: 0,
        title: "НДС 0%",
      },
      {
        value: -1,
        title: "НДС не облагается",
      },
      {
        value: 120,
        title: "НДС 20 /120",
      },
      {
        value: 110,
        title: "НДС 10 /110",
      },
    ],
  }),
  created() {
    this.onLoad();
  },
  computed: {
    ...mapFields("receipts_settings", ["savingInProgress", "fetched", "receipts_settings"]),
  },
  watch: {
    $route(to, from) {
      this.onLoad();
    },
  },
  methods: {
    fillReceiptsSettingsTemp() {
      this.receiptsSettingsTemp.nds = this.receipts_settings ? this.receipts_settings.nds : null;
      this.receiptsSettingsTemp.inn = (this.receipts_settings && this.receipts_settings.inn) ? this.receipts_settings.inn : '';

    },    
    onLoad() {
      this.$store.dispatch("receipts_settings/get").then(()=>{
        this.fillReceiptsSettingsTemp()
      })

    },
    submit() {
      if (this.$refs["kkmParamsForm"].validate()) {
        this.$store.dispatch("receipts_settings/store", this.receiptsSettingsTemp).then((res) => {});
      }
    },
  },
};
</script>

<style scoped></style>
